/**
 * backdropClick — the onClick for a hand-drawn modal backdrop: closes only
 * when the press ALSO began on the backdrop. A drag that starts inside the
 * card (selecting text in an input, sweeping a slider) and releases over the
 * backdrop fires `click` on the backdrop too — the browser targets the nearest
 * common ancestor of the press and the release — and used to close the modal
 * mid-edit. One capture listener remembers where the last press landed.
 * For Media Devoted | Created By James Alexandrov
 */

import type { MouseEvent } from "react";

let pressed: EventTarget | null = null;

if (typeof document !== "undefined") {
  document.addEventListener(
    "pointerdown",
    (e) => {
      pressed = e.target;
    },
    true,
  );
}

/** `onClose` undefined (a write in flight) makes the backdrop inert. */
export function backdropClick(
  onClose: (() => void) | undefined,
): (e: MouseEvent<HTMLElement>) => void {
  return (e) => {
    if (!onClose) return;
    if (e.target !== e.currentTarget) return;
    if (pressed !== e.currentTarget) return;
    onClose();
  };
}

export default backdropClick;
